import { CreateEmailResponse, CustomMailDTO, EmailDTO, EmailsHistoryFilters, EmailsMessagesDTO, FindAllCustomMailsResponseDTO, MailFilters } from '../app/pages/projects/mails/dto';
import { SendEmailFormValues, TemplateFormValues } from '../app/pages/projects/mails/validation';
import { baseApi } from './_baseQuery';


export const mailsApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        findOneEmail: build.query<EmailDTO, string>({
            query: (id) => ({
                url: "/notifications/find/" + id,
            }),
            providesTags: (_, __, id) => [{ type: 'Mails', id: id + '-email' }]
        }),
        findAllCustomMails: build.query<FindAllCustomMailsResponseDTO, MailFilters>({
            query: (filters) => ({
                url: "/notifications/custom-mail",
                params: {
                    ...filters
                }
            }),
            providesTags: [{ type: 'Mails', id: 'LIST-CUSTOM' }]
        }),
        findOneCustomMail: build.query<CustomMailDTO, string>({
            query: (id) => ({
                url: "/notifications/custom-mail/" + id,
            }),
            providesTags: (_, __, id) => [{ type: 'Mails', id: id + '-custom-mail' }]
        }),
        createEmail: build.mutation<CreateEmailResponse, TemplateFormValues>({
            query: (body) => ({
                url: "/notifications/custom-mail",
                method: "POST",
                body
            }),
            invalidatesTags: [{ type: 'Mails', id: 'LIST-CUSTOM' }]
        }),
        updateEmail: build.mutation<void, { id: string; data: TemplateFormValues }>({
            query: ({ id, data }) => ({
                url: `/notifications/custom-mail/${id}`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: (_result, _error, { id }) => [{ type: 'Mails', id: id + '-custom-mail' }, { type: 'Mails', id: 'LIST-CUSTOM' }],
        }),
        removeMail: build.mutation<void, { id: string }>({
            query: ({ id }) => ({
                url: `/notifications/custom-mail/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_result, _error, { id }) => [{ type: 'Mails', id: id + '-custom-mail' }, { type: 'Mails', id: 'LIST-CUSTOM' }],
        }),
        sendVerificationMail: build.mutation<void, string>({
            query: (request) => ({
                url: `/notifications/custom-mail/send-verification-mail`,
                method: 'POST',
                body: {
                    email: request
                }
            }),
            // invalidatesTags: (_result, _error, { mailId }) => [{ type: 'Mails', id: mailId + '-custom-mail' }],
        }),
        sendCustomMail: build.mutation<any, { customMailId: string, request: SendEmailFormValues, targetId: string }>({
            query: ({ customMailId, request, targetId }) => ({
                url: `/notifications/sendCustomEmail/${customMailId}`,
                params: { targetListId: targetId },
                method: 'POST',
                body: {
                    ...request
                }
            }),
            invalidatesTags: (_result, _error, { customMailId, targetId }) => [{ type: 'Mails', id: customMailId + '-custom-mail' }, { type: 'Mails', id: 'LIST-CUSTOM' }, { type: 'Mails', id: 'LIST-HISTORY-' + targetId }],
        }),
        findEmailsHistory: build.query<{ messages: EmailsMessagesDTO[] }, EmailsHistoryFilters>({
            query: (filters) => ({
                url: `/notifications/finds`,
                params: {
                    ...filters
                }
            }),
            providesTags: (_, __, filters) => [{ type: 'Mails', id: 'LIST-HISTORY-' + filters.targetListId }]
        }),
    }),
});

export const {
    useFindOneEmailQuery,
    useFindAllCustomMailsQuery,
    useFindOneCustomMailQuery,
    useCreateEmailMutation,
    useUpdateEmailMutation,
    useRemoveMailMutation,
    useSendVerificationMailMutation,
    useSendCustomMailMutation,
    useFindEmailsHistoryQuery,
} = mailsApi